import React, { ReactNode } from "react";
import Box from "@mui/material/Box";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DatePicker, DatePickerProps, DateValidationError, PickerChangeHandlerContext } from "@mui/x-date-pickers-pro";
import "dayjs/locale/nl";
import dayjs, { Dayjs } from "dayjs";

export type WcDatePickerProps = DatePickerProps & {
  controlDisabled?: boolean;
  children?: ReactNode;
  width?: number | string;
  required?: boolean;
  error?: any;
  format?: string;
  textFieldFullWidth?: boolean;
  fullWidth?: boolean;
  helperText?: string; //used in WCDatePickerControllers, applied in slotProps -> textfield -> helperText
};

export const WcDatePicker = (props: WcDatePickerProps) => {
  const { controlDisabled, width, required, error, format, value, fullWidth, slotProps, sx, onChange, ...rest } = props;
  const [localValue, setLocalValue] = React.useState<Dayjs | null>(value && value !== null ? dayjs(value) : null);
  const handleChange = (newValue: Dayjs | null, context: PickerChangeHandlerContext<DateValidationError>) => {
    setLocalValue(newValue);
    if (newValue && newValue !== null && newValue.isValid()) {
      onChange(newValue, context);
    }
  };

  return (
    <Box width={width ? width : fullWidth ? "100%" : 230} id="WcDatePicker">
      <LocalizationProvider adapterLocale={"nl"} dateAdapter={AdapterDayjs}>
        <DatePicker
          sx={[...(Array.isArray(sx) ? sx : [sx])]}
          disabled={controlDisabled}
          format={format ? format : "DD/MM/YYYY"}
          value={localValue && localValue !== null ? localValue : null}
          onChange={handleChange}
          slotProps={{
            ...slotProps,
          }}
          {...rest}
        />
      </LocalizationProvider>
    </Box>
  );
};

export default WcDatePicker;
